// Configuración de la API
export const API_CONFIG = {
  BASE_URL: import.meta.env.VITE_API_BASE_URL || 'http://localhost:9090/api/v1', // URL del backend
  API_KEY: import.meta.env.VITE_API_KEY || 'test',
  TIMEOUT: 10000, // 10 segundos
};

// Endpoints de la API
export const API_ENDPOINTS = {
  // Health Check
  HEALTH_CHECK: '/health-check',
  
  // Users
  USERS: '/users',
  USER_SIGN_UP: '/users/sign-up',
  USER_BY_ID: (id: string) => `/users/${id}`,
  
  // Roles
  ROLES: '/roles',
  
  // Restaurants (subrutas de system)
  RESTAURANTS: (userId: string) => `/system/users/${userId}/restaurants`,
  RESTAURANT_BY_ID: (userId: string, restaurantId: string) => `/system/users/${userId}/restaurants/${restaurantId}`,
  FEATURED_RESTAURANTS: (userId: string) => `/system/users/${userId}/restaurants/featured`,
  SEARCH_RESTAURANTS: (userId: string) => `/system/users/${userId}/restaurants/search`,
  
  // Restaurants públicos
  PUBLIC_RESTAURANTS: '/public/restaurants',
  PUBLIC_RESTAURANT_BY_ID: (restaurantId: string) => `/public/restaurants/${restaurantId}`,
  PUBLIC_VIRTUAL_TABLE_TOKEN: (restaurantId: string) => `/public/restaurants/${restaurantId}/virtual-table-token`,
  PUBLIC_FEATURED_RESTAURANTS: '/public/restaurants/featured',
  PUBLIC_SEARCH_RESTAURANTS: '/public/restaurants/search',
  
  // Categories (subrutas de system)
  CATEGORIES: (userId: string) => `/system/users/${userId}/categories`,
  CATEGORIES_BY_RESTAURANT: (userId: string, restaurantId: string) => `/system/users/${userId}/categories?restaurantId=${restaurantId}`,
  CATEGORY_BY_ID: (userId: string, categoryId: string) => `/system/users/${userId}/categories/${categoryId}`,
  
  // Categories públicos
  PUBLIC_CATEGORIES: '/public/categories',
  PUBLIC_CATEGORY_BY_ID: (categoryId: string) => `/public/categories/${categoryId}`,
  
  // Menu (público para GET, administrativo para POST/PUT/DELETE)
  MENU: '/public/menu',
  MENU_BY_ID: (id: string) => `/public/menu/${id}`,
  MENU_BY_CATEGORY: (categoryId: string) => `/public/menu/category/${categoryId}`,
  // Rutas administrativas de menú
  MENU_ADMIN: (userId: string) => `/system/users/${userId}/menu`,
  MENU_ADMIN_BY_ID: (userId: string, menuId: string) => `/system/users/${userId}/menu/${menuId}`,
  MENU_AVAILABILITY: (userId: string, menuId: string) => `/system/users/${userId}/menu/${menuId}/availability`,
  // Endpoints para items de menú
  MENU_ITEMS: (userId: string, restaurantId: string) => `/system/users/${userId}/restaurants/${restaurantId}/menu-items`,
  
  // Orders
  ORDERS: (userId: string, restaurantId: string) => `/system/users/${userId}/restaurants/${restaurantId}/orders`,
  ORDER_BY_ID: (userId: string, restaurantId: string, orderId: string) => `/system/users/${userId}/restaurants/${restaurantId}/orders/${orderId}`,
  ORDER_STATUS: (userId: string, restaurantId: string, orderId: string) => `/system/users/${userId}/restaurants/${restaurantId}/orders/${orderId}/status`,
  
  // Orders públicos
  PUBLIC_ORDERS: '/public/orders',

  // Reservations (administrativo)
  RESERVATIONS: (userId: string, restaurantId: string) => `/system/users/${userId}/restaurants/${restaurantId}/reservations`,
  RESERVATION_BY_ID: (userId: string, restaurantId: string, reservationId: string) => `/system/users/${userId}/restaurants/${restaurantId}/reservations/${reservationId}`,
  RESERVATION_SELECTION: (userId: string, restaurantId: string) => `/system/users/${userId}/restaurants/${restaurantId}/reservations/selection`,
  RESERVATION_SELECTION_BY_ID: (userId: string, restaurantId: string, selectionId: string) => `/system/users/${userId}/restaurants/${restaurantId}/reservations/selection/${selectionId}`,
  RESERVATION_STATUS: (userId: string, restaurantId: string, reservationId: string) => `/system/users/${userId}/restaurants/${restaurantId}/reservations/${reservationId}/status`,
  
  // Tables
  TABLES: (userId: string, restaurantId: string) => `/system/users/${userId}/restaurants/${restaurantId}/tables`,
  TABLE_BY_ID: (userId: string, restaurantId: string, tableId: string) => `/system/users/${userId}/restaurants/${restaurantId}/tables/${tableId}`,
  TABLE_STATUS: (userId: string, restaurantId: string, tableId: string) => `/system/users/${userId}/restaurants/${restaurantId}/tables/${tableId}/status`,
  
  // Waiters
  WAITERS: (userId: string, restaurantId: string) => `/system/users/${userId}/restaurants/${restaurantId}/waiters`,
  WAITER_BY_ID: (userId: string, restaurantId: string, waiterId: string) => `/system/users/${userId}/restaurants/${restaurantId}/waiters/${waiterId}`,
  WAITER_STATUS: (userId: string, restaurantId: string, waiterId: string) => `/system/users/${userId}/restaurants/${restaurantId}/waiters/${waiterId}/status`,
  WAITER_STATS: (userId: string, restaurantId: string) => `/system/users/${userId}/restaurants/${restaurantId}/waiters/stats`,
  
  // Responsibles
  RESPONSIBLES: (userId: string, restaurantId: string) => `/system/users/${userId}/restaurants/${restaurantId}/responsibles`,
  RESPONSIBLE_BY_ID: (userId: string, restaurantId: string, responsibleId: string) => `/system/users/${userId}/restaurants/${restaurantId}/responsibles/${responsibleId}`,
  
  // Analytics
  ANALYTICS: (userId: string, restaurantId: string, timeframe: string) => `/system/users/${userId}/restaurants/${restaurantId}/analytics?timeframe=${timeframe}`,
  
  // Recommendations (IA)
  RECOMMENDATIONS_BY_RESTAURANT: (restaurantId: string) => `/restaurants/${restaurantId}/recommendations`,
  
  // Dashboard
  DASHBOARD_STATS: (userId: string, restaurantId: string) => `/system/users/${userId}/restaurants/${restaurantId}/dashboard`,
  
  // System Management
  SYSTEM_MANAGEMENT: '/system',
  SET_USER_ROLE: (userId: string) => `/system/users/${userId}/permissions`,
  TOGGLE_RESTAURANT_STATUS: (restaurantId: string) => `/system/restaurants/${restaurantId}/status`,
  SYSTEM_STATS: '/system/users/:userId/statistics',
  
  // Stripe Products
  STRIPE_PRODUCTS: '/stripe/products',
  STRIPE_PRODUCT_BY_ID: (productId: string) => `/stripe/products/${productId}`,
  STRIPE_PRODUCT_PRICES: (productId: string) => `/stripe/products/${productId}/prices`,
};

// Estados de respuesta HTTP
export const HTTP_STATUS = {
  OK: 200,
  CREATED: 201,
  NO_CONTENT: 204,
  BAD_REQUEST: 400,
  UNAUTHORIZED: 401,
  FORBIDDEN: 403,
  NOT_FOUND: 404,
  INTERNAL_SERVER_ERROR: 500,
};

// Tipos de contenido
export const CONTENT_TYPES = {
  JSON: 'application/json',
  FORM_DATA: 'multipart/form-data',
};

// Headers por defecto
export const DEFAULT_HEADERS = {
  'Content-Type': CONTENT_TYPES.JSON,
  'Accept': CONTENT_TYPES.JSON,
}; 